import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { MdEdit, MdOutlineMail, MdWifiCalling3, MdOutlineAllInbox, MdLocationOn } from "react-icons/md";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ContactInfoAction } from "../../../Redux/action/ContactInfoAction";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const ApplyContactInfo = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    email: "",
    mobile: "",
    keyExperience: "",
    city: ""
  });

  const {
    email,
    mobile,
    keyExperience,
    city
  } = data;

  const userInfo = useSelector((state) => state.Profile.result);
  console.log(userInfo, "userInfoPro")

  let userData = userInfo;
  useEffect(() => {
    if (userData) {
      setData({ ...userData });
    }
  }, [userData]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const candidateId = userResult?.userid;;
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();

    let content = {
      candidateId,
      email,
      mobile,
      keyExperience,
      city
    };

    dispatch(ContactInfoAction(content));
  };

  const location = useLocation();

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Update Your Contact Information.
        </BootstrapDialogTitle>
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
            }}
          >
            <TextField fullWidth label="Email" value={email} name="email"
              onChange={handleInputChange} />
            <TextField fullWidth label="Mobile" value={mobile} name="mobile"
              onChange={handleInputChange} />
            <TextField fullWidth label="KeyExperience" name="keyExperience" value={keyExperience} onChange={handleInputChange} />
            <TextField fullWidth label="City" name="city" value={city} onChange={handleInputChange} />
          </Box>
          <DialogActions>
            <Button autoFocus type="submit">
              Save changes
            </Button>
          </DialogActions>
        </form>
      </BootstrapDialog>
      <div className="apply-profile-card8">
        <div className='edit-button'>
          <div className='overview'>
            <span style={{ fontWeight: "bold" }}>Contact Information</span>

            {location.state === null ? <><span onClick={handleClickOpen}><MdEdit /></span></> : console.log("data")}
          </div>
        </div>
        <div className='contact_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_info">
            <div className='contact_icon'><MdOutlineMail /></div>
            <div className="">
              <p className="">{userInfo?.email}</p>
            </div>
          </div>

        </div>
        <div className='contact_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_info">
            <div className='contact_icon'><MdWifiCalling3 /></div>
            <div className="">
              <p className="">{userInfo?.mobile}</p>
            </div>
          </div>

        </div>
        <div className='contact_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_info">
            <div className='contact_icon'><MdOutlineAllInbox /></div>
            <div className="">
              {userInfo?.keyExperience !== null && userInfo?.keyExperience !== "" ? <p className="">{userInfo?.keyExperience}</p> : <p className="Warning_data">Please Fill Your Key Experience</p>}

            </div>
          </div>

        </div>
        <div className='contact_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_info">
            <div className='contact_icon'><MdLocationOn /></div>
            <div className="">
              {userInfo?.city !== null && userInfo?.city !== "" ? <p className="">{userInfo?.city}</p> : <p className="Warning_data">Please Fill Your City</p>}

            </div>
          </div>

        </div>
      </div></>
  )
}

export default ApplyContactInfo